import React from "react"
import PropTypes from "prop-types"
import Button from "react-bootstrap/Button"
import classNames from "classnames"

import Icon from "app/static/frontend/components/Icon"
import "app/static/frontend/components/stylus/LoadingButton.styl"
/**
 * Component to render a loading button with a loading indicator. Passing down
 * props that a normal Button uses such as disabled to disable the LoadingButton
 * for reasons other than it loading.
 */

/** @type {(props: any) => React.ReactElement} */
export const LoadingButton = ({
    block,
    bsSize,
    buttonText,
    className,
    dataCy,
    disabled,
    icon,
    iconLeft,
    iconRight,
    id,
    isLoading,
    loadingIcon,
    loadingText,
    loadingTextClass,
    onClick,
    onClickArg,
    style,
    type,
    variant,
}) => {
    // on click handler
    const handleOnClick = () => {
        if (onClickArg) {
            return onClick(onClickArg)
        } else {
            return onClick()
        }
    }
    const fontSize = style?.fontSize || "inherit"
    return (
        <Button
            className={classNames(
                {
                    "btn-block": block,
                },
                className,
            )}
            data-cy={dataCy}
            disabled={isLoading || disabled}
            id={id}
            onClick={!isLoading ? handleOnClick : undefined}
            size={bsSize === "md" ? null : bsSize}
            style={style}
            type={type}
            variant={variant}
        >
            <div className="loading-div">
                {iconLeft && (
                    <div className={`loading-icon loading-icon-left ${isLoading && "is-loading"}`} style={{ fontSize }}>
                        {isLoading ? loadingIcon : icon}
                    </div>
                )}
                {/* Make sure there is a space between text and icon/s  */}
                <div className={loadingTextClass || "loading-text"} style={{ fontSize }}>
                    {isLoading ? `${loadingText}` : buttonText}
                </div>
                {iconRight && (
                    <div
                        className={`loading-icon loading-icon-right ${isLoading && "is-loading"}`}
                        style={{ fontSize }}
                    >
                        {isLoading ? loadingIcon : icon}
                    </div>
                )}
            </div>
        </Button>
    )
}

LoadingButton.propTypes = {
    block: PropTypes.bool,
    bsSize: PropTypes.string,
    buttonText: PropTypes.string.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.element,
    iconLeft: PropTypes.bool,
    iconRight: PropTypes.bool,
    id: PropTypes.string,
    isLoading: PropTypes.bool,
    loadingIcon: PropTypes.object,
    loadingText: PropTypes.string,
    loadingTextClass: PropTypes.string,
    onClick: PropTypes.func,
    onClickArg: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
    style: PropTypes.object,
    variant: PropTypes.string,
}

LoadingButton.defaultProps = {
    block: false,
    bsSize: "lg",
    className: "loading-button",
    disabled: false,
    icon: <Icon />,
    iconLeft: true,
    iconRight: false,
    id: "",
    isLoading: false,
    loadingIcon: <Icon name="fa-spinner fa-spin" />,
    loadingText: "Loading...",
    loadingTextClass: "",
    onClick: () => null,
    onClickArg: null,
    variant: "primary",
}

export default LoadingButton
